import { useEffect, useRef } from 'react';

export default function DisplayAd() {
  const adRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    let attempts = 0;
    const maxAttempts = 60; // try for up to 18 seconds (60 * 300 ms)

    const interval = setInterval(() => {
      attempts++;

      if (attempts > maxAttempts) {
        clearInterval(interval);
        return;
      }

      const el = adRef.current;
      if (!el) return;

      // Already loaded
      if (el.getAttribute('data-adsbygoogle-status') === 'done') {
        clearInterval(interval);
        return;
      }

      const width = el.clientWidth;
      if (width < 50) return; // skip if the width is still 0 or too small

      if (!window.adsbygoogle) return;

      try {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
        clearInterval(interval);
      } catch (e) {
        console.warn('AdSense load error:', e);
      }
    }, 300);

    return () => clearInterval(interval);
  }, []);

  return (
    <ins
      className="adsbygoogle"
      style={{ display: 'block', textAlign: 'center' }}
      data-ad-layout="in-article"
      data-ad-format="auto"
      data-ad-client="ca-pub-4429205354593554"
      data-ad-slot="6201854292"
      data-full-width-responsive="true"
    />
  );
}
